module.exports = __webpack_public_path__ + "img/ADDRESS.4639867f.svg";